/* ============================================================
   VIVEX: gedrag van de cijferkaarten.
   Bestand: assets/vivex-cijferkaarten.js
   Hoort bij sections/vivex-cijferkaarten.liquid en
   assets/vivex-cijferkaarten.css.

   Zonder GSAP, of bij "verminderde beweging", blijft alles gewoon
   leesbaar: de kaarten staan onder elkaar en de getallen staan
   meteen goed. Er wordt dan niets geladen.
   ============================================================ */
(function () {
  'use strict';

  var GSAP_URL = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ST_URL = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
  var beweging = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var laden = null;

  function alle(r, sel) { return Array.prototype.slice.call(r.querySelectorAll(sel)); }

  function laadScript(src) {
    return new Promise(function (ok, fout) {
      var s = document.createElement('script');
      s.src = src; s.async = false; s.onload = ok; s.onerror = fout;
      document.head.appendChild(s);
    });
  }
  /* GSAP alleen laden als het er nog niet staat. */
  function laadGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    if (!laden) laden = laadScript(GSAP_URL).then(function () { return laadScript(ST_URL); });
    return laden;
  }

  /* Het thema zet scroll-behavior:smooth op de pagina. Daardoor meet
     ScrollTrigger verkeerd na een herlaad of een formaatwijziging.
     We zetten het uit en laten ankerlinks zelf zacht scrollen. */
  function vastScrollen() {
    document.documentElement.style.setProperty('scroll-behavior', 'auto', 'important');
  }
  function zachteAnkers() {
    if (document.__vxCkAnkers) return;
    document.__vxCkAnkers = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var doel = id && document.getElementById(id);
      if (!doel) return;
      e.preventDefault();
      doel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* De kaarten moeten onder de vaste kop van de site blijven plakken.
     We meten die kop in plaats van een vast getal aan te houden. */
  function kopHoogte() {
    var kandidaten = ['.header-group', '#header-group', 'header.header', '.section-header', 'header'];
    for (var i = 0; i < kandidaten.length; i++) {
      var el = document.querySelector(kandidaten[i]);
      if (!el) continue;
      var h = el.getBoundingClientRect().height;
      if (h > 40 && h < 220) return Math.round(h) + 12;
    }
    return 92;
  }
  function zetKop(r) { r.style.setProperty('--vx-kop', kopHoogte() + 'px'); }

  /* Telt het getal op en laat de tekst erachter staan.
     Werkt ook met komma's en punten, zodat 4,5 L van 0,0 L naar 4,5 L telt
     en niet naar 4 L. */
  function telOp(el) {
    var m = /^(\d+(?:[.,]\d+)?)(.*)$/.exec(el.textContent.trim());
    if (!m) return;
    var ruw = m[1], rest = m[2];
    var scheider = ruw.indexOf(',') > -1 ? ',' : '.';
    var p = ruw.indexOf(scheider);
    var decimalen = p > -1 ? ruw.length - p - 1 : 0;
    var doel = parseFloat(ruw.replace(',', '.'));
    if (isNaN(doel)) return;

    function toon(v) {
      var s = v.toFixed(decimalen);
      if (scheider === ',') s = s.replace('.', ',');
      el.textContent = s + rest;
    }
    toon(0);
    var o = { v: 0 };
    window.gsap.to(o, {
      v: doel, duration: 1.6, ease: 'expo.out',
      onUpdate: function () { toon(o.v); },
      onComplete: function () { toon(doel); },
      scrollTrigger: { trigger: el, start: 'top 88%', once: true }
    });
  }

  /* De kaart eronder krimpt en wordt donkerder zodra de volgende
     eroverheen schuift. */
  function stapel(r) {
    var g = window.gsap, kaarten = alle(r, '.vx-ck__kaart');
    kaarten.forEach(function (k, i) {
      var volgende = kaarten[i + 1];
      if (!volgende) return;
      g.to(k, {
        scale: 0.92, '--donker': 0.3, ease: 'none',
        scrollTrigger: { trigger: volgende, start: 'top bottom', end: 'top 25%', scrub: true }
      });
    });
  }

  function init(r) {
    if (!r || r.__vxCkInit) return;
    r.__vxCkInit = true;
    zetKop(r);
    if (!beweging) return;

    laadGsap().then(function () {
      var ST = window.ScrollTrigger;
      window.gsap.registerPlugin(ST);
      vastScrollen();
      zachteAnkers();
      ST.addEventListener('refresh', vastScrollen);
      ST.addEventListener('refresh', function () { zetKop(r); });
      stapel(r);
      alle(r, '.vx-ck__groot').forEach(telOp);
      ST.refresh();
      window.addEventListener('load', function () { ST.refresh(); }, { once: true });
    }).catch(function () { /* geen GSAP: kaarten blijven gewoon leesbaar */ });
  }

  function start() { alle(document, '[data-vx-ck]').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* De thema-bewerker hertekent secties zonder de pagina te herladen. */
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-vx-ck]') : null;
    if (r) { r.__vxCkInit = false; init(r); }
  });
})();